import Dashboard from 'src/wrapper/dashboard/officer';
import Account from 'src/wrapper/account';
import StudentList from 'src/wrapper/students/list';
import StudentDetail from 'src/wrapper/students/detail';
import StudentTracking from 'src/wrapper/students/tracking';
import TeacherList from 'src/wrapper/officers/teacher-list';
import TeacherDetail from 'src/wrapper/officers/teacher-detail';
import CourseList from 'src/wrapper/officers/course-list';
import CourseDetail from 'src/wrapper/officers/course-detail';
import CourseStudent from 'src/wrapper/officers/course-student';
import CartList from 'src/wrapper/officers/cart-list';
import OrderList from 'src/wrapper/officers/order-list';
import AccStudentList from 'src/wrapper/accounts/student-list'
import AccStudentDetail from 'src/wrapper/accounts/student-detail';

export const officerRoutes = (paths) => {
  return [
    { path: paths.dashboard.index, component: Dashboard },
    { path: paths.dashboard.account, component: Account },
    { path: paths.students.index, component: StudentList },
    { path: paths.students.details, component: StudentDetail },
    { path: paths.accounts.studentList, component: AccStudentList },
    { path: paths.accounts.studentEdit, component: AccStudentDetail },
    { path: paths.tracking.items, component: StudentTracking },
    { path: paths.teachers.index, component: TeacherList },
    { path: paths.teachers.details, component: TeacherDetail },
    { path: paths.courses.index, component: CourseList },
    { path: paths.courses.details, component: CourseDetail },
    { path: paths.courses.student, component: CourseStudent },
    { path: paths.carts.index, component: CartList },
    { path: paths.orders.index, component: OrderList },
  ];
};
